export function round(value: number, decimals: number): number {
    // @ts-ignore
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
}

export function mvToPercent(value: number): number {
    return round((value * 100) / 3300, 1)
}

export function percentToMv(value: number): number {
    return round((value * 3300) / 100, 0)
}
